import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAFAFA' }}>
      <Navigation />

      <section className="text-white py-16" style={{ background: 'linear-gradient(135deg, #456A9E 0%, #4A6AA0 100%)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">{t('contact.title')}</h1>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#D6E0EE' }}>
            {t('contact.subtitle')}
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>
            <div className="lg:col-span-1">
              <ContactInfo />
            </div>
          </div>

          <div className="mt-10 text-center">
            <Link to="/" className="font-medium transition-colors" style={{ color: '#A8922A' }}
              onMouseEnter={e => e.currentTarget.style.color = '#7A6A1E'}
              onMouseLeave={e => e.currentTarget.style.color = '#A8922A'}
            >
              {t('contact.backLink')}
            </Link>
          </div>
        </div>
      </section>

      <footer className="text-white py-8 mt-8" style={{ backgroundColor: '#23395B' }}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm" style={{ color: '#94a3b8' }}>{t('contact.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
